import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminDeletePost = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('post_id',payload.post_id);


           try{
               const res = await axios.post(ENDPOINT+"delete-post.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminDeletePost